import { PreferenceSettingApi } from '@wiz-api/cloud-render-management'
import cloudRender from './index'

const preferenceApi = new PreferenceSettingApi()

let userPreferenceSettings = []
let defaultSettings = []
const PROJECT_NAME = Wiz.globalSettings.globalConfig?.modelSetting?.folderName || 'SAAS'
/**
 * @description: 获取默认设置
 * @return {*}
 */
const getDefaultSettings = async (player) => {
  const jsonData = await cloudRender.Setting.getSettingData(
    player,
    `data://../apps/${PROJECT_NAME}/settings.json`
  )
  if (jsonData && jsonData.status && jsonData.data) {
    defaultSettings = JSON.parse(jsonData.data)
  } else {
    defaultSettings.Show = (await cloudRender.Setting.getAll(player).data) || []
    const roamTrance = await cloudRender.Walking.getAllHotKey(player)
    defaultSettings.RoamTrance = _.reduce(
      roamTrance.data || [],
      (obj, item) => {
        obj[item.label] = item.code
        return obj
      },
      {}
    )
    defaultSettings.People = {
      avatarCapSkin: 'white',
      avatarBodySkin: 'red',
    }
  }
}
/**
 * @description: 获取用户偏好设置
 * @param {*} loadSetting 是否加载设置
 * @return {*}
 */
const getPreferenceSettings = async (loadSetting = false, player) => {
  const [err, res] = await preferenceApi.getCurrentUserSetting()
  if (!err && res) {
    const data = res.extraProperties
    userPreferenceSettings = data
    const modelDetail = (await JSON.parse(localStorage.getItem('modelDetail'))) || {}
    modelDetail.userPreferenceSettings = userPreferenceSettings
    localStorage.setItem('modelDetail', JSON.stringify(modelDetail))
    if (loadSetting) {
      setPreferenceSettings(player)
    }
  }
}
/**
 * @description: 设置用户偏好设置
 * @param {*} null
 * @return {*}
 */
const setPreferenceSettings = async (player) => {
  getPreferenceSettings(false, player)
  getDefaultSettings(player)
  if (userPreferenceSettings.Show) {
    const showData = await cloudRender.Setting.getAll(player)
    const showSettings = showData.data || []

    _.forIn(userPreferenceSettings.Show, (value, key) => {
      const settingInfo = _.find(showSettings, ['name', key])
      if (settingInfo) {
        let currentValue = ''
        if (settingInfo.type === 'bool') {
          currentValue = value === 'true' || value === true
        } else if (
          settingInfo.type === 'int' ||
          settingInfo.type === 'float' ||
          settingInfo.type === 'double'
        ) {
          currentValue = _.toNumber(value)
        } else {
          currentValue = value
        }
        cloudRender.Setting.set(player, {
          name: key,
          type: settingInfo.type,
          value: currentValue,
        })
      }
    })
  } else if (defaultSettings.Show) {
    _.forEach(defaultSettings.Show, (item) => {
      cloudRender.Setting.set(player, { name: item.name, type: item.type, value: item.value })
    })
  }
  const roamingSettings = userPreferenceSettings.RoamTrance
    ? userPreferenceSettings.RoamTrance
    : defaultSettings.RoamTrance
  _.forIn(roamingSettings, (value, key) => {
    let settingKeys = []
    if (userPreferenceSettings.RoamTrance) {
      const currentKeys = JSON.parse(value)
      settingKeys = currentKeys[0] || []
    } else {
      settingKeys = value[0] || []
    }
    cloudRender.Walking.setHotKeys(player, { name: key, code: settingKeys })
  })
  const RoamingSpeed = roamingSettings ? roamingSettings.RoamingSpeed : 1
  cloudRender.Walking.setAvatarSpeed(player, RoamingSpeed)
  const figureSettings = userPreferenceSettings.People
    ? userPreferenceSettings.People
    : defaultSettings.People
  const skinObj = {
    body: figureSettings.avatarBodySkin,
    head: figureSettings.avatarCapSkin,
  }
  cloudRender.Walking.setAvatarSkin(player, 'GongRen', skinObj)
}

// 系统设置显隐
const showPlayerSysSetting = async (val, player) => {
  // 获取player默认显示设置
  getDefaultSettings(player)
  getPreferenceSettings(false, player)
  if (!val) {
    // 获取用户偏好设置
    setPreferenceSettings(player)
  } else {
    _.forEach(defaultSettings.Show, (item) => {
      cloudRender.Setting.set(player, { name: item.name, type: item.type, value: item.value })
    })
    _.forIn(defaultSettings.RoamTrance, (value, key) => {
      const settingKeys = value[0] || []
      cloudRender.Walking.setHotKeys(player, { name: key, code: settingKeys })
    })
    const skinObj = {
      body: defaultSettings.People.avatarBodySkin,
      head: defaultSettings.People.avatarCapSkin,
    }
    cloudRender.Walking.setAvatarSkin(player, 'GongRen', skinObj)
  }
}
export { getPreferenceSettings, setPreferenceSettings, getDefaultSettings, showPlayerSysSetting }
